import { createTheme } from '@mui/material/styles';
import './ThemeTypes';

const CesamTheme = createTheme({
    palette: {
        common: {
            black: "#272727"
        },
        primary: {
            main: "#95c020",
            light: "#a3c934",
            dark: "#7ca01a"
        },
        secondary: {
            main: "#2596be",
            light: "#4faac6",
            dark: "#1d7a9a"
        },
        surface: {
            main: "#144129",
        }
    },
});

export default CesamTheme;